import { useMutation } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * tRPC implementation of recalculateAppetites (RSP-6486). The mutation takes no
 * input; `mutateAsync` resolves once the async request completes — the
 * data-layer endpoint runs the cascade SERVER-SIDE, returns 202 with the rich
 * `{ errorCode, message }` body, and emits the `AppetitesRecalculated`
 * completion event that closes the request-state-api request.
 *
 * The resolved value carries the gating `errorCode` (a *successful* outcome
 * meaning the cascade was skipped) so the caller can surface a specific
 * message. No `throwOnError`, no error `useEffect` — the caller owns display.
 */
export const useRecalculateAppetitesTRPC = () => {
  const trpc = useTRPC();
  const mutation = useMutation({
    ...trpc.frontend.aggregation.recalculateAppetites.mutationOptions(),
  });

  return {
    recalculateAppetites: async () => {
      const result = await mutation.mutateAsync(undefined);

      return { errorCode: result.errorCode };
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
